// Relays which network-level extensions are enabled to the service worker, which
// does the actual blocking (src/client/sw/sw.js). Which extensions those are
// comes from the shared registry (entries with a `sw` field). We only post a
// tiny message when the state actually changes - and the SW persists it - so
// this costs essentially nothing at runtime. Wired from app/main.js (and
// settings/main.js for the standalone settings page).
import { get, subscribe } from "../shared/settings-store.js";
import { SW_EXTENSIONS } from "../shared/extensions.js";

function cfg() {
	const c = {};
	SW_EXTENSIONS.forEach((x) => { c[x.sw] = get(x.key) === true; });
	return c;
}

let last = null;
function push(force) {
	const c = cfg();
	const key = SW_EXTENSIONS.map((x) => c[x.sw]).join("|");
	if (!force && key === last) return; // only talk to the SW when something changed
	last = key;
	try {
		const ctl = navigator.serviceWorker && navigator.serviceWorker.controller;
		if (ctl) ctl.postMessage({ type: "RV_EXT", cfg: c });
	} catch (e) {}
}

export function initExtensions() {
	if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
	push(true);
	// A freshly-activated SW (first load / new build) becomes our controller here -
	// re-send so it learns the current state even though nothing in settings changed.
	navigator.serviceWorker.addEventListener("controllerchange", () => push(true));
	// A worker that restarted asks again (its own stored copy is only a guess: sw.js).
	navigator.serviceWorker.addEventListener("message", (e) => { if (e.data && e.data.type === "RV_EXT_SYNC") push(true); });
	subscribe(() => push(false)); // re-sync on any settings change (no-ops unless ext flags moved)
}
